export default __webpack_public_path__ + "static/media/twitter.59e52208.svg";